import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";


import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./styles.css"

import { Navigation, Pagination } from "swiper/modules";
import { ProjectCard, projects } from "./ProjectCard";
import { Popup } from "./Popup";

export function ProjectSwiper({darkMode, setDarkMode ,popup, setPopup}) {


  return (
    <div className=" w-full">
      <Swiper
        modules={[Navigation, Pagination]}
        mousewheel={true}
        navigation={true}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        cssMode={true}
        breakpoints={{
          0: {
            // Mobile Screens (xs)
            slidesPerView: 1, // Show only 1 slide
            spaceBetween: 6, // No extra space
          },
          400: {
            // Mobile Screens (xs)
            slidesPerView: "auto", // Show only 1 slide
            spaceBetween: 20, // No extra space
          },
          1500: {
            // Mobile Screens (xs)
            slidesPerView: "auto", // Show only 1 slide
            spaceBetween: 30, // No extra space
          },
        }}
      >
        {projects.map((elemt, index) => (
          <SwiperSlide
            key={index}
            className="!w-full sm:!w-[350px]  !max-w-[350px] !min-w-[250px]"
          >
            <ProjectCard
              title={elemt.title}
              description={elemt.description}
              link={elemt.link}
              setPopup={setPopup}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {popup && <Popup darkMode={darkMode} setDarkMode={setDarkMode} setPopup={setPopup} title={popup} />}
    </div>
  );
}
